













































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import RequestsService from '@/mixins/requests.service';
import CurrentUserService from '@/mixins/currentUser.service';
import UsersService from '@/mixins/users.service';
import FiltersService from '@/mixins/filters.service';
import { EventFilters } from '@/components/_common/';
import { User, UserId } from '@/types/user';
import { Request, RequestId, LeaveTypeId } from '@/types/request';
declare interface RequestsTableHeader {
  text: string;
  align?: 'left' | 'right' | 'center';
  value: string;
}

@Component({
  components: {
    EventFilters,
  },
  mixins: [ RequestsService, UsersService, FiltersService, CurrentUserService ],
})
export default class RequestsTable extends Mixins(UsersService, RequestsService, FiltersService, CurrentUserService) {
  private headers: RequestsTableHeader[] = [
    {
      text: 'Start Date',
      align: 'left',
      value: 'dateStart',
    },
    {
      text: 'End Date',
      align: 'left',
      value: 'dateEnd',
    },
    {
      text: 'Type',
      align: 'left',
      value: 'leaveTypeId',
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status',
    },
    {
      text: 'Added',
      align: 'left',
      value: 'createdAt',
    },
    {
      text: 'Last Changed',
      align: 'left',
      value: 'updatedAt',
    },
    {
      text: 'Actions',
      value: 'action',
    },
  ];

  get adminHeaders(): RequestsTableHeader[] {
    return [
      {
        text: 'Employee',
        align: 'left',
        value: 'userId',
      },
      ...this.headers,
    ];
  }

  private onEditRequestClick(requestItem: Request): Promise<any> {
    return this.$store.dispatch('addEditRequest/showModal', requestItem);
  }

  get tableEvents(): Request[] {
    return this.applyRequestFilters(this.requests);
  }


  private created(): void {
    this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: false });
    this.$store.dispatch('requestStatuses/update', { force: false });
    this.$store.dispatch('requests/updateRequests');
    this.$store.dispatch('userRoles/update');
    this.$store.dispatch('users/updateUsers', { force: false });
  }

}
